import React, { Fragment, useState, useEffect } from 'react';
import { Button, Form, Alert, FloatingLabel, Col, Row } from 'react-bootstrap';
import DiarioService from '../../../../services/diario-auth';
import { Link } from 'react-router-dom';
import Moment from 'moment';



/*async function getDiarios() {
    let resposta = await fetch('http://localhost:3000/api/darios.json')
    let nvdiario = await resposta.json()
    return nvdiario
}*/



const Diario = () => {
    const [edicao, setEdicao] = useState("");
    const [dataPub, setDataPub] = useState("");
    const [mes, setMes] = useState("");
    const [ano, setAno] = useState("");
    const [numAnexos, setNumAnexos] = useState(false);
    const [anexos, setAnexos] = useState("");
    const [error, setError] = useState([]);
    const [arquivo, setArquivo] = useState([]);
    const [sucesso, setSucesso] = useState(false);
    //const [novasDiarios, setNovas] = useState([]);

    /*useEffect(() => {
         getDiarios().then(data => {
             setNovas(data['diarios'])
         })
     }, [])
 
     const enfiatudo = async () => {
         novasDiarios.map(async (item) => {
             const diario = await DiarioService.cadastro(
                 {
                     cod_diario: parseInt(item.cod_diario),
                     edicao: item.edicao,
                     data_p: item.data_p,
                     mes: item.mes,
                     ano: item.ano,
                     arquivo: item.arquivo,
                     num_anexos: item.num_anexos,
                     anexos: item.anexos
                 }
             )
             })}*/


    const handleUpload = (e) => setArquivo(e.target.files[0]);


    const montaForm = async () => {
        const diario = new FormData();
        diario.append("edicao", edicao)
        diario.append("data_p", dataPub)
        diario.append("ano", ano)
        diario.append("mes", mes)
        diario.append("num_anexos", numAnexos)
        diario.append("anexos", anexos);
        diario.append("arquivo", arquivo);
        return diario
    }

    const HandleSubmit = async (evt) => {
        evt.preventDefault()
        const dados = await montaForm();
        try {
            const lei = await DiarioService.cadastro(dados)
            setSucesso(true)
            setError(false)
        } catch (error) {
            setError(error)
        }
    }

    const addNovo = (evt) => {
        evt.preventDefault()
        setSucesso(false)
        setEdicao("")
        setDataPub("")
        setAno("")
        setMes("")
        setNumAnexos("")
        setAnexos("")
        setArquivo("")
        setError([]);
    }

    if (!sucesso) {
        return (
            <Fragment>
                {/*<Button onClick={enfiatudo}>Importar Diários</Button>*/}
                <Form onSubmit={HandleSubmit} encType="multipart/form-data">
                    <Row xs={1} lg={4}>
                        <Col>
                            <Form.Group className="mb-3" controlId="Edicao">
                                <FloatingLabel
                                    label="Edição"
                                    className="mb-3"
                                >
                                    <Form.Control
                                        required
                                        type="text"
                                        name="edicao"
                                        value={edicao}
                                        onChange={e => setEdicao(e.target.value)} />
                                </FloatingLabel>
                            </Form.Group>
                        </Col>
                        <Col>
                            <Form.Group className="mb-3" controlId="DataDiario">
                                <FloatingLabel
                                    label="Data da Publicação"
                                    className="mb-3"
                                >
                                    <Form.Control
                                        required
                                        type="date"
                                        name="data_p"
                                        value={dataPub}
                                        onChange={e => setDataPub(e.target.value)}
                                    />
                                </FloatingLabel>
                            </Form.Group>
                        </Col>
                        <Col>
                            <Form.Group className="mb-3" controlId="Mês">
                                <FloatingLabel
                                    label="Mês"
                                    className="mb-3"
                                >
                                    <Form.Select
                                        required
                                        aria-label="Mês"
                                        name="mes"
                                        onChange={e => setMes(e.target.value)}
                                    >
                                        <option>SELECIONE</option>
                                        <option value="1">Janeiro</option>
                                        <option value="2">Fevereiro</option>
                                        <option value="3">Março</option>
                                        <option value="4">Abril</option>
                                        <option value="5">Maio</option>
                                        <option value="6">Junho</option>
                                        <option value="7">Julho</option>
                                        <option value="8">Agosto</option>
                                        <option value="9">Setembro</option>
                                        <option value="10">Outubro</option>
                                        <option value="11">Novembro</option>
                                        <option value="12">Dezembro</option>
                                    </Form.Select>
                                </FloatingLabel>
                            </Form.Group>
                        </Col>
                        <Col>
                            <Form.Group className="mb-3" controlId="Ano">
                                <FloatingLabel
                                    label="Ano"
                                    className="mb-3"
                                >
                                    <Form.Select
                                        required
                                        aria-label="Ano"
                                        name="ano"
                                        onChange={e => setAno(e.target.value)}
                                    >
                                        <option>SELECIONE</option>
                                        <option value="2025">2025</option>
                                        <option value="2024">2024</option>
                                        <option value="2023">2023</option>
                                        <option value="2022">2022</option>
                                        <option value="2021">2021</option>
                                        <option value="2026">2026</option>
                                    </Form.Select>
                                </FloatingLabel>
                            </Form.Group>
                        </Col>
                    </Row>

                    <Row xs={1} lg={2}>
                        <Col lg={2}>

                            <Form.Group className="mb-3" controlId="Anexos?">
                                <Form.Check
                                    type="switch"
                                    id="numAnexos"
                                    name="numAnexos"
                                    checked={numAnexos}
                                    onChange={e => setNumAnexos(e.target.checked)}
                                    label="Tem anexos?"
                                />
                            </Form.Group>
                        </Col>
                        {numAnexos ?
                            <Col>
                                <Form.Group className="mb-3" controlId="anexos">
                                    <FloatingLabel
                                        label="Anexo"
                                        className="mb-3"
                                    >
                                        <Form.Control
                                            type="text"
                                            name="anexos"
                                            value={anexos}
                                            onChange={e => setAnexos(e.target.value)}
                                            placeholder="Cole aqui o link" />
                                    </FloatingLabel>
                                </Form.Group>
                            </Col> : ''}
                    </Row>
                    <Row xs={12}>
                        <Col lg={4}>
                            <Form.Group className="mb-3" controlId="arquivo">
                                <Form.Label>Arquivo do Diário</Form.Label>
                                <Form.Control
                                    required
                                    type="file"
                                    name="arquivo"
                                    onChange={handleUpload}
                                    accept="application/pdf"

                                />
                            </Form.Group>
                        </Col>
                    </Row>
                    {error.length >= 1 ? <Alert variant="danger"> {[...error]}</Alert> : ''}
                    <Button variant="primary" type="submit">
                        Cadastrar
                    </Button>
                </Form >
                <br />
                <Link to={'/restrito/diario'}>
                    <Button variant="danger" type="button">
                        Voltar
                    </Button>
                </Link>
            </Fragment >
        )
    } else {
        return (
            <Fragment>
                <Alert variant='success'>Edição cadastrada com sucesso!</Alert>
                <Button onClick={addNovo} variant="success" type="submit">
                    Adicionar outra
                </Button>
                <br /><br />
                <Link to={'/restrito/diario/listar'}>
                    <Button variant="primary" type="button">
                        Ir para Listagem de Edições
                    </Button>
                </Link>
                <br /><br />
                <Link to={'/restrito/diario'}>
                    <Button variant="danger" type="button">
                        Voltar
                    </Button>
                </Link>
            </Fragment>
        )
    }
}

export default Diario;